<template>
  <div class="container" id="goods-edit">
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form
        ref="form"
        label-width="110px"
        class="info-form"
        style="margin-top: 22px"
        :rules="rules"
        :model="form"
      >
        <el-form-item label="用户昵称" prop="userName">
          <el-input
            placeholder="请输入用户昵称"
            v-model="form.userName"
            style="width: 442px"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户头像" prop="userAvatar">
          <upload-picture
            :imageUrl="form.userAvatar"
            :width="'128px'"
            :height="'128px'"
            @getUrl="getImage"
          ></upload-picture>
        </el-form-item>
        <el-form-item label="选择商品" prop="psGoodsId">
          <el-input
            placeholder="请选择商品"
            readonly
            v-model="form.psGoodsName"
            style="width: 442px"
            @focus="selectGoods"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品规格" prop="psGoodsSku">
          <el-select
            style="width: 442px"
            v-model="form.psGoodsSku"
            placeholder="请选择商品规格"
            filterable
            clearable
          >
            <el-option
              v-for="item in skus"
              :key="item.psGoodsSku"
              :label="item.psGoodsSkuName"
              :value="item.psGoodsSku"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评论星数" prop="star">
          <el-select
            style="width: 442px"
            v-model="form.star"
            placeholder="请选择星数"
            filterable
            clearable
          >
            <el-option
              v-for="item in stars"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评论时间" prop="submitTime">
          <el-date-picker
            style="width: 442px"
            v-model="form.submitTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="评论内容" prop="content">
          <el-input
            placeholder="请输入评论内容"
            type="textarea"
            :rows="3"
            v-model="form.content"
            style="width: 442px"
            maxlength="200"
            show-word-limit
            
          >
          </el-input>
        </el-form-item>
        <el-form-item label="评论图片">
          <upload-picture1
            :limit="100000"
            :isCustomer="1"
            :list="fileList"
            @changeImage="changeImage"
          />
          <div class="messageI">
            图片尺寸：建议上传大小不得超过2M,支持jpg、jpeg、png格式
          </div>
        </el-form-item>
        <el-form-item label="状态" prop="showFlag">
          <el-select
            style="width: 442px"
            v-model="form.showFlag"
            placeholder="请选择状态"
            filterable
            clearable
          >
            <el-option label="显示" value="true"></el-option>
            <el-option label="隐藏" value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="height: 20px"></div>
      <div class="back-btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="primary" @click="save()">确认</el-button>
      </div>
    </div>

    <el-dialog
      title="选择商品"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="dialogGoods"
      width="50%"
    >
      <div style="height: 500px; overflow-y: auto">
        <div class="search-box">
          <el-input
            placeholder="请输入商品名称/商品编号"
            size="small"
            style="width: 224px; margin-right: 20px"
            v-model="goodsInfo"
          ></el-input>
          <el-button type="primary" @click="fetchData('search')" size="small"
            >查询</el-button
          >
        </div>
        <el-table
          :data="goodsList"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :show-header="false"
          border
        >
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column prop="goodsName" label="">
            <template slot-scope="scope">
              <div style="display: flex">
                <img
                  :src="scope.row.imgUrl"
                  style="width: 72px; height: 56px; margin-right: 12px"
                  alt=""
                />
                <div
                  style="
                    font-size: 14px;
                    height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  "
                >
                  <p style="color: #333333">{{ scope.row.goodsName }}</p>
                  <p style="color: #999999">
                    商品编号：{{ scope.row.goodsNo }}
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            display: flex;
            justify-content: end;
            align-items: center;
            height: 42px;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>

      <div style="display: flex; justify-content: end; margin-top: 24px">
        <div class="info-q" @click="dialogGoods = false">取消</div>
        <div class="info-s" @click="selectD">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import uploadPicture from '@/components/upload/mallPicture.vue'
import uploadPicture1 from '@/components/upload/dragpicturew.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    uploadPicture,
    uploadPicture1
  },
  data () {
    return {
      skus: [],
      stars: [
        {
          id: 1,
          name: '一星'
        },
        {
          id: 2,
          name: '二星'
        },
        {
          id: 3,
          name: '三星'
        },
        {
          id: 4,
          name: '四星'
        },
        {
          id: 5,
          name: '五星'
        },
      ],
      goodsInfo: '',
      fileList: [],
      goodsList: [


      ],
      dialogGoods: false,
      radio: '1',
      startTime: [],
      expireDates: [

      ],
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '商品评论', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '新增评论', path: '', type: '0' }
        ]
      },
      checked1: true,
      checked2: false,
      radio: 3,
      name: '---',
      dialogUser: false,
      currentPage4: 1,
      tableData: [

      ],
      tableDataF: [

      ],
      detail: {},
      form: {
        id: '',
        userAvatar: '',
        userName: '',
        psGoodsId: '',
        psGoodsSku: '',
        imgList: [],
        star: '',
        content: '',
        showFlag: '',
        submitTime: '',
        psGoodsName: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户昵称', trigger: 'blur' },
        ],
        submitTime: [
          { required: true, message: '请选择评论时间', trigger: 'change' },
        ],
        userAvatar: [
          { required: true, message: '请上传用户头像', trigger: 'change' },
        ],
        psGoodsId: [
          { required: true, message: '请选择商品', trigger: 'change' },
        ],
        psGoodsSku: [
          { required: true, message: '请选择商品规格', trigger: 'change' },
        ],
        star: [
          { required: true, message: '请选择星数', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请输入评论内容', trigger: 'blur' },
        ],
        showFlag: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
      },
      arr: [],
      pageNo: 1,
      pageSize: 10,
      totalNum: 0,
      selectData: [],
    }
  },
  created () {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id
      this.getDetail()
    }

  },

  methods: {
    save () {
      console.log(this.form)
      
      let arr = []
      this.fileList.forEach(item => {
        arr.push(item.url)
      })
      this.form.imgList=arr
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.axios.post('/psGoodsEvaluation/save', this.form)
            .then(res => {
              console.log(res)
              if (res.code == 0) {
                this.$message.success('保存成功')
                this.$router.push({
                  name: 'shopComment',

                })
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    selectD () {
      console.log(this.selectData)
      this.dialogGoods = false
      this.form.psGoodsId = this.selectData.goodsId
      this.form.psGoodsName = this.selectData.goodsName
      this.axios.get('/sys/index/findPlatformGoodsSkuList?psGoodsId=' + this.selectData.goodsId).then(res => {
        if (res.code == 0) {
          this.skus = res.data
        }
      })
    },
    changeImage (val) {
      this.fileList = val
      console.log(val)
      // this.$refs.form.clearValidate('userAvatar')
    },
    getImage (val) {
      this.form.userAvatar = val
      this.$refs.form.clearValidate('userAvatar')
    },
    getGList () {
      let data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        goodsInfo: this.goodsInfo
      }
      this.axios.post('/sys/index/getGoodsPage', data).then(res => {
        if (res.code == 0) {
          this.goodsList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    fetchData () {
      this.pageNo = 1
      this.getGList()
    },
    selectGoods () {
      console.log(88888888)
      this.dialogGoods = true
      this.getGList()

    },
    back () {
      this.$router.go(-1)
    },
    select () {
      console.log(this.arr)
    },
    getDetail () {
      this.axios.get('psGoodsEvaluation/get?id=' + this.$route.query.id)
        .then(res => {
          if (res.code == 0) {
            this.form = res.data
            this.form.userAvatar=res.data.userAvatar?res.data.userAvatar:require('../../../assets/icon_touxiang_106@2x.png')
            this.form.showFlag = String(res.data.showFlag)
            this.form.psGoodsId = res.data.psGoodsId
            this.form.psGoodsName = res.data.goodsName
            let arr = []
            res.data.imgList.forEach(item => {
              let obj = {
                url: item,
              }
              arr.push(obj)
            })
            this.fileList = arr
            this.axios.get('/sys/index/findPlatformGoodsSkuList?psGoodsId=' + res.data.psGoodsId).then(res => {
              if (res.code == 0) {
                this.skus = res.data
              }
            })
          }
        })
    },
    handleCurrentChange (e) {
      this.pageNo = e
      this.getGList()
    },
    handleSizeChange (e) {
      this.pageNo = 1
      this.pageSize = e
      this.getGList()
    },
    handleSelectionChange (e) {
      this.selectData = [];
      if (e.length > 1) {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleRowSelection(
          e[e.length - 1]
        );
      }
      this.selectData = e[e.length - 1]
    }
  }
}
</script>
<style scoped lang="scss">
.messageI {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  // margin-top: 7px;
  color: #909099;
}
.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}
.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.search-box {
  width: 100%;
  height: 50px;
  background: #f8f8f8;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid #e8eaec;
  border-bottom: 0;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #ebeefa;
  border-color: #c0c0cc;
  color: #c0c4cc;
  cursor: not-allowed;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: left !important;
}
.detail {
  width: 378px;
  min-height: 82px;
  background: #ebeefa;
  opacity: 1;
  border-radius: 3px;
  padding: 10px 10px;
  line-height: 30px;
  color: #303033;
}
.s-label {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #303033;
  opacity: 1;
}
.start {
  width: 10px;
  height: 10px;
  background: #13ce4b;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}
.end {
  width: 10px;
  height: 10px;
  background: #f63c56;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
.back-btn {
  width: 30%;
  text-align: left;
  padding-bottom: 20px;
  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }
}
</style>

